import { z } from "zod"

export const passwordSchema = z.object({
    username: z.string().min(1, "Este campo es obligatorio"),
    phoneNumber: z.string().min(1, "Este campo es obligatorio"),
    currentPassword: z.string().min(1, "Este campo es obligatorio"),
    confirmPassword: z.string().min(1, "Este campo es obligatorio")
}).refine(
    (data) => data.currentPassword === data.confirmPassword,
    {
        path: ["confirmPassword"],
        message: "Las contraseñas no coinciden",
    }
)


export type ChangeSPasswordForm = z.infer<typeof passwordSchema>